import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import ReactLoading from 'react-loading';
import _ from 'lodash';
import moment from 'moment';
import classNames from 'classnames';
import {
  emptyImage,
  getCloudImageUrl,
} from '../../../../../../../utils';
import {
  accessoriesCondition,
  boxCondition,
  boxHandbag,
  dustBag,
  formatCurrency,
  handbagCondition,
  sneakersCondition,
  sneakersDefect,
  displayItem,
  yellowing,
  sneakerDefectsCondition,
  handleStatusConsignment,
  handleColorStatusConsignment,
} from '../../../../../../../utils/Helpers';
import RightArrowIcon from "../../../../../../../images/right-arrow-icon.png";

interface ModalPending {
  isOpen: boolean;
  ratio: number;
  currency: string;
  data: [];
  onToggle: () => any;
  type: string;
}

const Review = ({
  data,
  ratio,
  currency,
  luxuryDetail,
  sneakersDetail,
  txtStatus,
}) => {
  const isReview = txtStatus === "Awaiting Review";
  const isAuthenticationProcess = txtStatus === "Authentication Process";

  return (
    <>
      <div className={'grey-box-section'}>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Consignment ID</p>
            <p className={'value'}>{data?.consignment_id}</p>
          </div>
        </div>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Consignment Price</p>
            <p className={'value'}>
              {formatCurrency(data?.asking_price, ratio, currency)}
            </p>
          </div>
        </div>
        {
          isReview ? (
            <div className={'container-row'}>
              <div className={'item'}>
                <p className={'title'}>Date Requested</p>
                <p className={'value'}>
                  {data?.created_at
                    ? moment(data?.created_at).format('MMMM DD, YYYY')
                    : '-'}
                </p>
              </div>
            </div>
          ) : (isAuthenticationProcess ? (
            <div className={'container-row'}>
              <div className={'item'}>
                <p className={'title'}>Receive At</p>
                <p className={'value'}>
                  {data?.created_at
                    ? moment(data?.created_at).format('MMMM DD, YYYY')
                    : '-'}
                </p>
              </div>
            </div>
          ) : null)
        }
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Product Conditions</p>
            <p className={'value'}>
              {data?.product_variant?.product?.category.name === 'handbags'
                ? luxuryDetail
                : sneakersDetail}
            </p>
          </div>
        </div>
        {data?.hypequarter_display && (
          <div className={'hq-wrapper'}>
            <p className={'hq-text'}>Hypequarter Display</p>
          </div>
        )}
      </div>

      <div className={'info-section'}>
        <p>Please consistently check your emails and notifications to receive any information regarding your consignment</p>
      </div>
    </>
  )
}

const Approved = ({
  data,
  ratio,
  currency,
  luxuryDetail,
  sneakersDetail,
  onClickDeliveryMethod,
  actionStatus,
}) => {
  return (
    <>
      <div className={'grey-box-section'}>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Consignment ID</p>
            <p className={'value'}>{data?.consignment_id}</p>
          </div>
        </div>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Consignment Price</p>
            <p className={'value'}>
              {formatCurrency(data?.asking_price, ratio, currency)}
            </p>
          </div>
        </div>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Product Conditions</p>
            <p className={'value'}>
              {data?.product_variant?.product?.category.name === 'handbags'
                ? luxuryDetail
                : sneakersDetail}
            </p>
          </div>
        </div>
        {data?.hypequarter_display && (
          <div className={'hq-wrapper'}>
            <p className={'hq-text'}>Hypequarter Display</p>
          </div>
        )}
      </div>

      <div className={'info-section'}>
        <p>Please consistently check your emails and notifications to receive any information regarding your consignment</p>
      </div>

      <div className={'info-section confirmation-text'}>
        <p>Please deliver the goods ASAP and input the AWB on your Consignment Dashboard. Please ensure you’ve read the instructions we’ve sent to your email {data?.user?.email}</p>
      </div>
      <div className={'delivery-method'} onClick={() => onClickDeliveryMethod(data)}>
        {
          actionStatus === 'isSelectDeliveryMethod' ?
          <p>Select Delivery Method <img src={RightArrowIcon} alt="..." className="right-arrow" /></p> :
          <p>Schedule a Pick Up <img src={RightArrowIcon} alt="..." className="right-arrow" /></p>
        }
      </div>
    </>
  )
}

const EnRoute = ({
  data,
  ratio,
  currency,
  luxuryDetail,
  sneakersDetail,
  onClickTrackingShipper,
  onClickTrackingPackage,
  type,
  onClickReceivePackage,
}) => {
  const isShipper = data?.sell_consignments?.shipper !== null;
  const status = handleStatusConsignment(data, type);
  const isShowTrackPackage = isShipper && ['En Route to Kick Avenue'].includes(status);
  const isShowPackageReceived = ['On The Way To You'].includes(status);
  
  return (
    <>
      <div className={'grey-box-section'}>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Consignment ID</p>
            <p className={'value'}>{data?.consignment_id}</p>
          </div>
        </div>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Consignment Price</p>
            <p className={'value'}>
              {formatCurrency(data?.asking_price, ratio, currency)}
            </p>
          </div>
        </div>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Shipped At</p>
            {
              isShowPackageReceived ? 
                <p className={'value'}>
                  {data?.sell_consignments?.ka_sent
                    ? moment(data?.sell_consignments?.ka_sent).format('MMMM DD, YYYY')
                    : '-'}
                </p> :
                <p className={'value'}>
                {data?.sell_consignments?.seller_sent
                  ? moment(data?.sell_consignments?.seller_sent).format('MMMM DD, YYYY')
                  : '-'}
                </p>
            }
          </div>
        </div>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Delivery Method</p>
            {
              isShowPackageReceived ? 
              <p className={'value'}>
                {data?.sell_consignments?.ka_courier || '-'}
              </p>
              :
              <p className={'value'}>
                {data?.sell_consignments?.seller_courier || '-'}
              </p>
            }
          </div>
          <div className={'item'}>
            <p className={'title'}>AWB Number</p>
            {
              isShowPackageReceived ? 
              <p className={'value'}>
                {data?.sell_consignments?.ka_awb_number || '-'}
              </p>
              :
              <p className={'value'}>
                {data?.sell_consignments?.seller_awb_number || '-'}
              </p>
            }
          </div>
        </div>
        <div className={'container-row'}>
          <div className={'item'}>
            <p className={'title'}>Product Conditions</p>
            <p className={'value'}>
              {data?.product_variant?.product?.category.name === 'handbags'
                ? luxuryDetail
                : sneakersDetail}
            </p>
          </div>
        </div>
        {data?.hypequarter_display && (
          <div className={'hq-wrapper'}>
            <p className={'hq-text'}>Hypequarter Display</p>
          </div>
        )}
      </div>

      <div className={'info-section'}>
        <p>Please consistently check your emails and notifications to receive any information regarding your consignment</p>
      </div>

      {
        isShowTrackPackage &&
        <div className={'delivery-method'} onClick={() => onClickTrackingShipper(data)}>
          <p>Track Package <img src={RightArrowIcon} alt="..." className="right-arrow" /></p>
        </div>
      }
      {
        isShowPackageReceived && 
        <div className={'delivery-method'} onClick={() => onClickReceivePackage(data)}>
          <p>Package Received</p>
        </div>
      }
    </>
  )
}

const handleConsignmentAction = (data) => {
  const sellConsignments = data?.sell_consignments;

  const trackPackageStatuses = [
    'ka_returned_seller',
    'seller_sent',
    'pickup_requested',
    'picked_up',
    'delivered',
  ];

  // check if status is in trackPackageStatuses for seller items
  if (trackPackageStatuses.includes(sellConsignments?.shipper?.status?.toLowerCase())) {
    return 'isTrackPackage';
  }

  // check if status is in trackPackageStatuses for returned items
  if (trackPackageStatuses.includes(sellConsignments?.status.toLowerCase())) {
    return 'isTrackPackage';
  }

  const isSchedulePickUp = sellConsignments?.shipper?.status?.toLowerCase() === 'new';

  if (isSchedulePickUp) {
    return 'isSchedulePickUp';
  }

  const isApprovedConsignmentAndNewStatus = data.status === 'consignment_approved' && sellConsignments?.status === 'NEW';

  if (isApprovedConsignmentAndNewStatus) {
    return 'isSelectDeliveryMethod';
  }

  return 'isReview';
}  


function ModalPendingComponent({
  isOpen,
  onToggle,
  ratio,
  currency,
  data,
  onClickDeliveryMethod,
  onClickTrackingShipper,
  onClickTrackingPackage,
  type,
  onClickReceivePackage,
  isFetchingModal,
}) {
  // If data is available, then show the modal
  if (data) {
    const isDefects = data?.defects?.length > 0
    const uniqueDefects = _.uniqBy(
      isDefects ? data?.defects : null,
      'name',
    );
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'DUST_BAG' && a.value)
      : {};
    const boxConditions = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'BOX')
      : {};
    const hideBoxInfo = data?.product_variant?.hide_box_info;
    const isVintage = data?.product_variant?.vintage;
    const sneakersDetailArr = [
      isVintage? "Vintage" : sneakersCondition(data?.sneakers_condition),
      hideBoxInfo ? '' : boxCondition(data?.box_condition),
      accessoriesCondition(data?.missing_accessories),
      yellowing(data?.yellowing),
      displayItem(data?.display_item),
      sneakersDefect(data?.sneakers_defect), 
      isDefects ? sneakerDefectsCondition(uniqueDefects, ', ') : ''
    ];
    const sneakersDetail = sneakersDetailArr.filter((item) => item !== '')
      .map((items) => items)
      .join(', ');
    const luxuryDetailArr = [
      sneakersCondition(data?.sneakers_condition),
      accessoriesCondition(data?.missing_accessories),
      dustBag(dustBagCondition),
      hideBoxInfo ? '' : boxHandbag(boxConditions),
      isDefects ? handbagCondition(uniqueDefects, ', ') : '',
    ];
    const luxuryDetail = luxuryDetailArr
      .filter((item) => item !== '' && item !== 'Missing Box')
      .map((item) => item)
      .join(', ');
    const category = data?.product_variant?.product?.category.name;
    const imageUrl = data?.product_variant?.product_variant_images?.length
      ? data?.product_variant?.product_variant_images[0].URL
      : null;
    const txtStatus = handleStatusConsignment(data, type);
    const isGreenStatus = handleColorStatusConsignment(txtStatus) === '#159953'
    const isYellowStatus = handleColorStatusConsignment(txtStatus) === '#FFCA25'
    const actionStatus = handleConsignmentAction(data);
    return (
      <Modal
        className="offer-detail-modal"
        toggle={onToggle}
        isOpen={isOpen}
        centered
      >
        <>
          <div className={'content-modal'}>
            <div className={'header-section'}>
              <div className={'left'}>
                <p className={'product-title'}>
                  {data?.product_variant?.display_name}
                </p>
                <p className={'product-sku'}>{data?.product_variant?.SKU}</p>
              </div>
              <div className={'right'}>
                <div>
                  {category === 'handbags' ||
                  (category === 'lifestyles' &&
                    data?.size?.US.toLowerCase() !== 'all size') ? (
                    <div className={'size-container'}>
                      <p>{data?.size?.US}</p>
                    </div>
                  ) : (
                    <div className={'size-container'}>
                      <p>US {data?.size?.US}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={'image-section'}>
              <img
                src={
                  imageUrl
                    ? getCloudImageUrl(imageUrl, 300)
                    : emptyImage(category)
                }
              />
            </div>
            <div className={classNames("status-section", { 'green': isGreenStatus, 'yellow': isYellowStatus })}>
              <p>{txtStatus}</p>
            </div>

            {isFetchingModal ? (
              <ReactLoading
                type={'spin'}
                height={50}
                width={50}
                color={'#159953'}
              />
            ) : (
              <>
                {
              ((actionStatus === 'isSelectDeliveryMethod') || (actionStatus === 'isSchedulePickUp')) && (
                <Approved
                  data={data}
                  ratio={ratio}
                  currency={currency}
                  luxuryDetail={luxuryDetail}
                  sneakersDetail={sneakersDetail}
                  onClickDeliveryMethod={(data) => onClickDeliveryMethod(data)}
                  actionStatus={actionStatus}
                />
              )
            }

            {
              actionStatus === 'isTrackPackage' && (
                <EnRoute
                  data={data}
                  ratio={ratio}
                  currency={currency}
                  luxuryDetail={luxuryDetail}
                  sneakersDetail={sneakersDetail}
                  onClickTrackingShipper={(data) => onClickTrackingShipper(data)}
                  onClickTrackingPackage={(data) => onClickTrackingPackage(data)}
                  type={type}
                  onClickReceivePackage={(data) => onClickReceivePackage(data)}
                />
              )
            }

            {
              actionStatus === 'isReview' && (
                <Review
                  data={data}
                  ratio={ratio}
                  currency={currency}
                  luxuryDetail={luxuryDetail}
                  sneakersDetail={sneakersDetail}
                  txtStatus={txtStatus}
                />
              )
            }
              </>
            )
          }
          </div>
        </>
      </Modal>
    )
  }
  // Not rendering the modal component is data is unavailable to prevent undefined error
  return <div />;
}

const mapStateToProps = (state) => {
  return {
    currency: state.dataAuth.userCurrency.currency,
    ratio: state.dataAuth.userCurrency.ratio,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalPendingComponent);